<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="tabs-header">
        <TabsDropdownSelector
          :current-container-width="instructionPanelWidth"
          :tabs="tabs"
          :active-tab="activeTab"
          :disabled="isSavingComputed"
          @change-tab="changeTab"
        />
        <b-loading v-model="isSavingComputed" :is-full-page="false"></b-loading>
      </div>

      <b-tabs v-model="activeTab" vertical :animated="false" class="block InstructionModale-tabs">
        <b-tab-item :label="$t('instruction-panel.instruction.instructeurs.title')">
          {{ $t("instruction-panel.instruction.instructeurs.text") }}
          <ul class="instructeurs-list">
            <li v-for="ins in getInstructeurs()" :key="ins">{{ ins }}</li>
          </ul>
        </b-tab-item>
        <b-tab-item :label="$t('instruction-panel.instruction.deroule.title')">
          <ResponsiveEvaluationHelp
            :criteria="$t('instruction-panel.instruction.deroule.title')"
            :help-text="$t('instruction-panel.instruction.deroule.help' + renewalHelpSuffix)"
          />
          <SelectWithValidation
            v-if="isRenouvellementLight(projetAnnuel.typeDossier)"
            v-model="derouleNote"
            :label="$t('instruction-panel.instruction.note')"
            vid="derouleNote"
            :data="notes"
            :disabled="readOnly"
            @manual-change="computeNote"
          />
          <SelectWithValidation
            v-else
            v-model="derouleNote"
            :label="$t('instruction-panel.instruction.note')"
            vid="derouleNote"
            :data="notes"
            :disabled="readOnly"
            rules="required"
            @manual-change="computeNote"
          />

          <InputWithValidation
            v-if="isRenouvellementLight(projetAnnuel.typeDossier)"
            v-model="derouleCommentaire"
            type="textarea"
            :label="$t('instruction-panel.instruction.commentaire')"
            maxlength="700"
            vid="derouleCommentaire"
            :disabled="readOnly"
          />
          <InputWithValidation
            v-else
            v-model="derouleCommentaire"
            type="textarea"
            :label="$t('instruction-panel.instruction.commentaire')"
            maxlength="700"
            vid="derouleCommentaire"
            rules="required"
            :disabled="readOnly"
          />

          <b-message v-if="readOnly && !isEvaluationFinale" type="is-warning">
            <span v-html="$t('instructionPage.labellisations.harmonisation.readonly-cloture')" />
          </b-message>
          <b-message v-else>
            {{ $t("instruction-panel.instruction.commentaires-non-visibles-warning") }}
          </b-message>
        </b-tab-item>

        <b-tab-item :label="$t('instruction-panel.instruction.adhesion.title')">
          <ResponsiveEvaluationHelp
            :criteria="$t('instruction-panel.instruction.adhesion.title')"
            :help-text="$t('instruction-panel.instruction.adhesion.help' + renewalHelpSuffix)"
          />

          <SelectWithValidation
            v-if="isRenouvellementLight(projetAnnuel.typeDossier)"
            v-model="adhesionNote"
            :label="$t('instruction-panel.instruction.note')"
            vid="adhesionNote"
            :data="notes"
            :disabled="readOnly"
            @manual-change="computeNote"
          />
          <SelectWithValidation
            v-else
            v-model="adhesionNote"
            :label="$t('instruction-panel.instruction.note')"
            vid="adhesionNote"
            :data="notes"
            rules="required"
            :disabled="readOnly"
            @manual-change="computeNote"
          />

          <InputWithValidation
            v-if="isRenouvellementLight(projetAnnuel.typeDossier)"
            v-model="adhesionCommentaire"
            type="textarea"
            :label="$t('instruction-panel.instruction.commentaire')"
            maxlength="700"
            vid="adhesionCommentaire"
            :disabled="readOnly"
          />
          <InputWithValidation
            v-else
            v-model="adhesionCommentaire"
            type="textarea"
            :label="$t('instruction-panel.instruction.commentaire')"
            maxlength="700"
            vid="adhesionCommentaire"
            rules="required"
            :disabled="readOnly"
          />

          <b-message v-if="readOnly && !isEvaluationFinale" type="is-warning">
            <span v-html="$t('instructionPage.labellisations.harmonisation.readonly-cloture')" />
          </b-message>
          <b-message v-else>
            {{ $t("instruction-panel.instruction.commentaires-non-visibles-warning") }}
          </b-message>
        </b-tab-item>

        <b-tab-item :label="$t('instruction-panel.instruction.integration.title')">
          <ResponsiveEvaluationHelp
            :criteria="$t('instruction-panel.instruction.integration.title')"
            :help-text="$t('instruction-panel.instruction.integration.help' + renewalHelpSuffix)"
          />

          <SelectWithValidation
            v-if="isRenouvellementLight(projetAnnuel.typeDossier)"
            v-model="integrationNote"
            :label="$t('instruction-panel.instruction.note')"
            vid="integrationNote"
            :data="notes"
            :disabled="readOnly"
            @manual-change="computeNote"
          />
          <SelectWithValidation
            v-else
            v-model="integrationNote"
            :label="$t('instruction-panel.instruction.note')"
            vid="integrationNote"
            :data="notes"
            rules="required"
            :disabled="readOnly"
            @manual-change="computeNote"
          />

          <InputWithValidation
            v-if="isRenouvellementLight(projetAnnuel.typeDossier)"
            v-model="integrationCommentaire"
            type="textarea"
            :label="$t('instruction-panel.instruction.commentaire')"
            maxlength="700"
            vid="integrationCommentaire"
            :disabled="readOnly"
          />
          <InputWithValidation
            v-else
            v-model="integrationCommentaire"
            type="textarea"
            :label="$t('instruction-panel.instruction.commentaire')"
            maxlength="700"
            vid="integrationCommentaire"
            rules="required"
            :disabled="readOnly"
          />
          <b-message v-if="readOnly && !isEvaluationFinale" type="is-warning">
            <span v-html="$t('instructionPage.labellisations.harmonisation.readonly-cloture')" />
          </b-message>
          <b-message v-else>
            {{ $t("instruction-panel.instruction.commentaires-non-visibles-warning") }}
          </b-message>
        </b-tab-item>

        <b-tab-item :label="$t('instruction-panel.instruction.implication.title')">
          <ResponsiveEvaluationHelp
            :criteria="$t('instruction-panel.instruction.implication.title')"
            :help-text="$t('instruction-panel.instruction.implication.help' + renewalHelpSuffix)"
          />

          <SelectWithValidation
            v-if="isRenouvellementLight(projetAnnuel.typeDossier)"
            v-model="implicationNote"
            :label="$t('instruction-panel.instruction.note')"
            vid="implicationNote"
            :data="notes"
            :disabled="readOnly"
            @manual-change="computeNote"
          />
          <SelectWithValidation
            v-else
            v-model="implicationNote"
            :label="$t('instruction-panel.instruction.note')"
            vid="implicationNote"
            :data="notes"
            rules="required"
            :disabled="readOnly"
            @manual-change="computeNote"
          />

          <InputWithValidation
            v-if="isRenouvellementLight(projetAnnuel.typeDossier)"
            v-model="implicationCommentaire"
            type="textarea"
            :label="$t('instruction-panel.instruction.commentaire')"
            maxlength="700"
            vid="implicationCommentaire"
            :disabled="readOnly"
          />
          <InputWithValidation
            v-else
            v-model="implicationCommentaire"
            type="textarea"
            :label="$t('instruction-panel.instruction.commentaire')"
            maxlength="700"
            vid="implicationCommentaire"
            rules="required"
            :disabled="readOnly"
          />

          <b-message v-if="readOnly && !isEvaluationFinale" type="is-warning">
            <span v-html="$t('instructionPage.labellisations.harmonisation.readonly-cloture')" />
          </b-message>
          <b-message v-else>
            {{ $t("instruction-panel.instruction.commentaires-non-visibles-warning") }}
          </b-message>
        </b-tab-item>

        <b-tab-item
          v-if="!readOnly && !isEvaluationFinale"
          :label="$t('instruction-panel.instruction.labellisation')"
        >
          <div v-if="evaluationCopy.note >= 0 && evaluationCopy.mentionAutomatique">
            <b-field
              :label="$t('instruction-panel.instruction.total')"
              :message="$t('instruction-panel.instruction.note-placeholder')"
              :disabled="readOnly"
            >
              <span>{{ evaluation.note }} {{ $t("instruction-panel.instruction.points") }}</span>
            </b-field>
            <b-field
              :label="$t('instruction-panel.instruction.mention')"
              :message="$t('instruction-panel.instruction.mention-placeholder')"
              :disabled="readOnly"
            >
              <span
                >{{ $t("instruction-panel.instruction." + evaluation.mentionAutomatique) }}
              </span>
            </b-field>
          </div>
          <span v-else>
            {{ $t("instruction-panel.instruction.calcul-non-disponible") }}
          </span>
        </b-tab-item>
        <b-tab-item
          :label="$t('instruction-panel.instruction.appreciation')"
          class="informations-visibles"
        >
          <InputWithValidation
            v-model="commentaireInstructeur"
            :rules="isRenouvellementLight(projetAnnuel.typeDossier) ? '' : 'required'"
            type="textarea"
            :label="$t('instruction-panel.instruction.commentaireInstructeur')"
            :input-notice="$t('instruction-panel.instruction.commentaireInstructeur-placeholder')"
            maxlength="700"
            vid="commentaireInstructeur"
            :disabled="readOnly"
            :validation-activated="true"
          />

          <b-tooltip
            v-if="!isEvaluationFinale"
            class="mail-preview-tooltip"
            type="is-light"
            position="is-bottom"
            multilined
            :active="emailDisplayed"
            always
          >
            <b-button type="is-primary" @click="emailDisplayed ? undisplayMail() : displayMail()">
              <span class="ellipsize" :style="{ 'max-width': instructionPanelWidth - 180 + 'px' }">
                {{ $t("instruction-panel.instruction.displayEmail") }}
              </span>
            </b-button>
            <template #content>
              <div class="mail-preview" v-html="emailText" />
            </template>
          </b-tooltip>

          <SelectWithValidation
            v-model="mention"
            :label="$t('instruction-panel.instruction.mention')"
            :input-notice="$t('instruction-panel.instruction.mention-finale-placeholder')"
            vid="mention"
            :data="instructionStatus"
            :select-labels="statusLabels"
            :rules="isRenouvellementLight(projetAnnuel.typeDossier) ? '' : 'required'"
            :disabled="readOnly"
            :validation-activated="true"
          />

          <b-message v-if="readOnly && !isEvaluationFinale" type="is-warning">
            <span v-html="$t('instructionPage.labellisations.harmonisation.readonly-cloture')" />
          </b-message>
        </b-tab-item>
      </b-tabs>

      <div class="bottom-buttons-evaluation">
        <!-- Save actions -->
        <div class="buttons">
          <b-button type="is-primary" :disabled="readOnly" @click="save()">
            {{ $t("instruction-panel.instruction.save") }}
          </b-button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import TabsDropdownSelector from "@/views/commons/TabsDropdownSelector.vue"
import {
  EvaluationDTO,
  ProjetAnnuelDTO,
  StatutDossier,
  TypeDossier,
} from "@/model/bean/GeneratedDTOs"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import SelectWithValidation from "@/views/inputs/SelectWithValidation.vue"
import ResponsiveEvaluationHelp from "./ResponsiveEvaluationHelp.vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import { EmailService } from "@/services/rest/email/EmailService"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import { BButton, BMessage, BTooltip, BLoading, BField, BTabs, BTabItem } from "buefy"

export default defineComponent({
  name: "EvaluationPanel",
  components: {
    InputWithValidation,
    SelectWithValidation,
    ValidationObserver,
    TabsDropdownSelector,
    ResponsiveEvaluationHelp,
    BButton,
    BField,
    BMessage,
    BTooltip,
    BTabs,
    BTabItem,
    BLoading,
  },
  props: {
    projetAnnuel: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    evaluation: {
      type: Object as PropType<EvaluationDTO>,
      required: true,
    },
    instructionPanelWidth: {
      type: Number,
      required: true,
    },
    instructionModal: {
      type: Boolean,
      default: true,
    },
    renewalSuffix: {
      type: String,
      default: "",
    },
    renewalHelpSuffix: {
      type: String,
      default: "",
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isEvaluationFinale: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["is-saving-updated", "evaluation-updated", "save-evaluation"],
  data() {
    return {
      emailService: EmailService.INSTANCE,
      inforReportingService: InfoReportingService.INSTANCE,
      internalProjetAnnuel: new ProjetAnnuelDTO(),
      emailDisplayed: false,
      emailText: "",
      activeTab: 0,
      tabs: [] as Array<string>,
      instructionStatus: [
        "ACCEPTE",
        "AVIS_PASSABLE",
        "LABELLISATION_EN_DEVENIR",
        "REFUSE",
        "AUTOMATISE",
      ] as StatutDossier[],
      statusLabels: [] as string[],
      notes: [""] as string[],
      evaluationCopy: { ...this.evaluation },
      isSavingCopy: this.isSaving,
    }
  },
  computed: {
    // Propriétés calculées avec setters pour éviter la mutation des props
    isSavingComputed: {
      get(): boolean {
        return this.isSavingCopy
      },
      set(value: boolean) {
        this.isSavingCopy = value
      },
    },
    derouleNote: {
      get(): string {
        return this.evaluationCopy.derouleNote
      },
      set(value: string) {
        this.evaluationCopy.derouleNote = value
        this.$emit("evaluation-updated", this.evaluationCopy)
      },
    },
    derouleCommentaire: {
      get(): string {
        return this.evaluationCopy.derouleCommentaire
      },
      set(value: string) {
        this.evaluationCopy.derouleCommentaire = value
        this.$emit("evaluation-updated", this.evaluationCopy)
      },
    },
    adhesionNote: {
      get(): string {
        return this.evaluationCopy.adhesionNote
      },
      set(value: string) {
        this.evaluationCopy.adhesionNote = value
        this.$emit("evaluation-updated", this.evaluationCopy)
      },
    },
    adhesionCommentaire: {
      get(): string {
        return this.evaluationCopy.adhesionCommentaire
      },
      set(value: string) {
        this.evaluationCopy.adhesionCommentaire = value
        this.$emit("evaluation-updated", this.evaluationCopy)
      },
    },
    integrationNote: {
      get(): string {
        return this.evaluationCopy.integrationNote
      },
      set(value: string) {
        this.evaluationCopy.integrationNote = value
        this.$emit("evaluation-updated", this.evaluationCopy)
      },
    },
    integrationCommentaire: {
      get(): string {
        return this.evaluationCopy.integrationCommentaire
      },
      set(value: string) {
        this.evaluationCopy.integrationCommentaire = value
        this.$emit("evaluation-updated", this.evaluationCopy)
      },
    },
    implicationNote: {
      get(): string {
        return this.evaluationCopy.implicationNote
      },
      set(value: string) {
        this.evaluationCopy.implicationNote = value
        this.$emit("evaluation-updated", this.evaluationCopy)
      },
    },
    implicationCommentaire: {
      get(): string {
        return this.evaluationCopy.implicationCommentaire
      },
      set(value: string) {
        this.evaluationCopy.implicationCommentaire = value
        this.$emit("evaluation-updated", this.evaluationCopy)
      },
    },
    commentaireInstructeur: {
      get(): string {
        return this.evaluationCopy.commentaireInstructeur
      },
      set(value: string) {
        this.evaluationCopy.commentaireInstructeur = value
        this.$emit("evaluation-updated", this.evaluationCopy)
      },
    },
    mention: {
      get(): StatutDossier {
        return this.evaluationCopy.mention
      },
      set(value: StatutDossier) {
        this.evaluationCopy.mention = value
        this.$emit("evaluation-updated", this.evaluationCopy)
      },
    },
  },

  watch: {
    projetAnnuel(): void {
      this.dossierInscriptionChanged()
    },
    evaluation: {
      handler(newEvaluation) {
        this.evaluationCopy = { ...newEvaluation }
      },
      deep: true,
      immediate: true,
    },
    isSaving: {
      handler(newIsSaving) {
        this.isSavingCopy = newIsSaving
      },
      immediate: true,
    },
  },
  created(): void {
    this.refreshInternalDossierFromDossier()
    this.statusLabels = this.instructionStatus.map((status) => {
      return this.$t(`instruction-panel.instruction.${status}`).toString()
    })
  },
  mounted(): void {
    if (this.isRenouvellementLight(this.projetAnnuel.typeDossier)) {
      this.notes = [" ", "A", "B", "C", "D"]
    } else {
      this.notes = ["A", "B", "C", "D"]
    }
  },
  methods: {
    dossierInscriptionChanged(): void {
      this.refreshInternalDossierFromDossier()
    },

    async refreshInternalDossierFromDossier(): Promise<void> {
      this.internalProjetAnnuel = this.projetAnnuel
      // Cannot set "EN DEVENIR" status for renewals
      if (
        this.isRenouvellementLight(this.internalProjetAnnuel.typeDossier) ||
        this.internalProjetAnnuel.typeDossier === "DOSSIER_RENOUVELLEMENT"
      ) {
        this.instructionStatus = ["ACCEPTE", "AVIS_PASSABLE", "REFUSE"]
        this.statusLabels = this.instructionStatus.map((status) => {
          return this.$t(`instruction-panel.instruction.${status}`).toString()
        })
      } else {
        this.instructionStatus = ["ACCEPTE", "AVIS_PASSABLE", "REFUSE", "LABELLISATION_EN_DEVENIR"]
        this.statusLabels = this.instructionStatus.map((status) => {
          return this.$t(`instruction-panel.instruction.${status}`).toString()
        })
      }
      this.tabs = [
        this.$t("instruction-panel.instruction.instructeurs.title").toString(),
        this.$t("instruction-panel.instruction.deroule.title").toString(),
        this.$t("instruction-panel.instruction.adhesion.title").toString(),
        this.$t("instruction-panel.instruction.integration.title").toString(),
        this.$t("instruction-panel.instruction.implication.title").toString(),
      ]
      if (!this.isEvaluationFinale && !this.readOnly) {
        this.tabs.push(this.$t("instruction-panel.instruction.labellisation").toString())
      }
      this.tabs.push(this.$t("instruction-panel.instruction.appreciation").toString())
    },

    isRenouvellementLight(typeDossier: TypeDossier): boolean {
      return typeDossier == "DOSSIER_RENOUVELLEMENT_LIGHT"
    },

    computeNote(): void {
      let noteDeroule = 0
      switch (this.evaluationCopy.derouleNote) {
        case "A":
          noteDeroule = 10
          break
        case "B":
          noteDeroule = 7
          break
        case "C":
          noteDeroule = 5
          break
        case "D":
          noteDeroule = 0
          break
      }

      let noteImplication = 0
      switch (this.evaluationCopy.implicationNote) {
        case "A":
          noteImplication = 10
          break
        case "B":
          noteImplication = 7
          break
        case "C":
          noteImplication = 5
          break
        case "D":
          noteImplication = 0
          break
      }

      let noteIntegration = 0
      switch (this.evaluationCopy.integrationNote) {
        case "A":
          noteIntegration = 5
          break
        case "B":
          noteIntegration = 3
          break
        case "C":
          noteIntegration = 1
          break
        case "D":
          noteIntegration = 0
          break
      }

      let noteAdhesion = 0
      switch (this.evaluationCopy.adhesionNote) {
        case "A":
          noteAdhesion = 3
          break
        case "B":
          noteAdhesion = 2
          break
        case "C":
          noteAdhesion = 1
          break
        case "D":
          noteAdhesion = 0
          break
      }

      const noteFinale = noteDeroule + noteImplication + noteIntegration + noteAdhesion

      this.evaluationCopy.note = noteFinale

      if (noteFinale >= 15) {
        // A labellisation is "good" only if its finale grade is above 15 AND if the grade for "deroule" and "implacation" are at least "B"
        if (
          (this.evaluationCopy.derouleNote == "A" || this.evaluationCopy.derouleNote == "B") &&
          (this.evaluationCopy.implicationNote == "A" || this.evaluationCopy.implicationNote == "B")
        ) {
          this.evaluationCopy.mentionAutomatique = "ACCEPTE"
        } else {
          this.evaluationCopy.mentionAutomatique = "AVIS_PASSABLE"
        }
      } else if (noteFinale >= 10) {
        this.evaluationCopy.mentionAutomatique = "AVIS_PASSABLE"
      } else {
        this.evaluationCopy.mentionAutomatique = "REFUSE"
      }

      // Met à jour la mention finale seulement si l'utilisateur n'en a pas choisi une manuellement (sinon il pourrait y avoir des changements de mention automatique qui écraseraient le choix de l'utilisateur)
      this.evaluationCopy.mention = this.evaluationCopy.mentionAutomatique

      this.$emit("evaluation-updated", this.evaluationCopy)
    },

    changeTab(tabIndex: number): void {
      this.activeTab = tabIndex
    },

    validationFieldEvaluation(evaluation: EvaluationDTO): boolean {
      return !!(
        evaluation.adhesionCommentaire &&
        evaluation.adhesionNote &&
        evaluation.derouleCommentaire &&
        evaluation.derouleNote &&
        evaluation.implicationCommentaire &&
        evaluation.implicationNote &&
        evaluation.integrationCommentaire &&
        evaluation.integrationNote &&
        evaluation.commentaireInstructeur &&
        evaluation.mention
      )
    },

    async save(): Promise<void> {
      const isRequiredFieldWarning =
        this.projetAnnuel.typeDossier != "DOSSIER_RENOUVELLEMENT_LIGHT" &&
        !this.validationFieldEvaluation(this.evaluationCopy)
      const reportingMessage =
        this.$t("instruction-panel.instruction.evaluation-saved").toString() +
        (isRequiredFieldWarning ? " " + this.$t("profilePage.field-required-warn").toString() : "")

      try {
        this.$emit("save-evaluation", this.evaluationCopy)

        if (isRequiredFieldWarning) {
          this.inforReportingService.warn(reportingMessage, new Error())
        } else {
          this.inforReportingService.success(reportingMessage)
        }
      } catch (e: any) {
        this.inforReportingService.error((e as Error).toString(), e as Error)
      }
    },

    async displayMail(): Promise<void> {
      if (this.evaluation.mention) {
        this.emailText = await this.emailService.getLabellisationEmail(
          this.evaluation.mention,
          this.projetAnnuel.id,
        )
      } else {
        this.emailText = this.$t(
          "instruction-panel.instruction.evaluation-mail-no-preview",
        ).toString()
      }
      this.emailDisplayed = true
    },

    undisplayMail(): void {
      this.emailText = ""
      this.emailDisplayed = false
    },

    getInstructeurs(): string[] {
      return this.projetAnnuel.lastEvaluationInstructeurNames.split(",")
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.bottom-buttons-evaluation {
  position: absolute;
  right: 80px;
  bottom: 20px;
}

.ellipsize {
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
}

.mail-preview {
  background-color: white;
}

.mail-preview-tooltip {
  top: -30px;
  padding-bottom: 20px;

  .tooltip-content {
    background-color: $sidepanel-background-color !important;
    min-width: 280px !important;
    text-align: left;

    .evaluation-help-tooltip-content {
      min-height: 200px;
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      background-color: $sidepanel-background-color;

      h3 {
        color: $text-default-color;
        font-size: 18px;
        padding-bottom: 3px;
        font-weight: bolder;
      }

      span {
        color: $text-default-color;
      }
    }
  }

  .tooltip-trigger {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

.instructeurs-list {
  li {
    padding: 10px;
    margin-left: 30px;
    list-style-type: circle;
  }
}
</style>
